export const dateWithoutTime = (str: string) => {
  const date = new Date(str);

  return date.toLocaleDateString('ru');
};

export const dateWithTime = (str: string) => {
  const date = new Date(str);
  const dateTime = date.toLocaleDateString('ru', {
    hour: 'numeric',
    minute: 'numeric',
  }).split(', ').join(' ');

  return `${dateTime} Мск`
};
